import { createContext, useContext, useMemo } from 'react'

type GalleryContextProps = {
  youtubeLink: string
}

export const GalleryContext = createContext<GalleryContextProps | undefined>(undefined)

export const useGalleryContext = () => {
  const context = useContext(GalleryContext)
  if (context === undefined) {
    throw new Error('useGalleryContext must be used inside a GalleryProvider')
  }
  return context
}

export function GalleryContextProvider({
  children,
  youtubeLink,
}: {
  children: React.ReactNode
  youtubeLink: string
}) {
  const memoizedValue = useMemo(() => ({ youtubeLink }), [youtubeLink])
  return <GalleryContext.Provider value={memoizedValue}>{children}</GalleryContext.Provider>
}
